export default "__VITE_ASSET__DTm6nRT3__"